import { render, staticRenderFns } from "./CaseTypeSelector.vue?vue&type=template&id=f129da16&scoped=true&"
import script from "./CaseTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./CaseTypeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CaseTypeSelector.vue?vue&type=style&index=0&id=f129da16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f129da16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
